// @ts-nocheck
import React, { forwardRef } from "react";

// Custom styles for SoftTypography
import SoftTypographyRoot from "./SoftTypographyRoot";

interface SoftTypographyProps {
  color?: "inherit" | "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark" | "text" | "white";
  fontWeight?: false | "light" | "regular" | "medium" | "bold";
  textTransform?: "none" | "capitalize" | "uppercase" | "lowercase";
  verticalAlign?: "unset" | "baseline" | "sub" | "super" | "text-top" | "text-bottom" | "middle" | "top" | "bottom";
  textGradient?: boolean;
  opacity?: number;
  children: React.ReactNode;
  [x: string]: any; // Allow additional props
}

const SoftTypography = forwardRef<HTMLSpanElement, SoftTypographyProps>(
  ({ color = "dark", fontWeight = false, textTransform = "none", verticalAlign = "unset", textGradient = false, opacity = 1, children, ...rest }, ref) => (
    <SoftTypographyRoot
      {...rest}
      ref={ref}
      ownerState={{ color, textTransform, verticalAlign, fontWeight, opacity, textGradient }}
    >
      {children}
    </SoftTypographyRoot>
  )
);

export default SoftTypography;
